var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 4.16667C42.0958 4.16667 45.8333 7.90417 45.8333 12.5V37.5C45.8333 42.0958 42.0958 45.8333 37.5 45.8333H12.5C7.90417 45.8333 4.16667 42.0958 4.16667 37.5V12.5C4.16667 7.90417 7.90417 4.16667 12.5 4.16667H37.5ZM37.5 0H12.5C5.59583 0 0 5.59583 0 12.5V37.5C0 44.4042 5.59583 50 12.5 50H37.5C44.4042 50 50 44.4042 50 37.5V12.5C50 5.59583 44.4042 0 37.5 0Z",
    fill: "#2942FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7439 35.4166C20.2169 35.4166 19.6919 35.2166 19.2856 34.8208L13.3335 28.9874C12.5127 28.1833 12.5002 26.8645 13.3044 26.0416C14.1106 25.2187 15.4314 25.2083 16.2502 26.0104L20.7439 30.4166L34.1648 17.2625C34.9877 16.4583 36.3064 16.4666 37.1106 17.2916C37.9169 18.1125 37.9044 19.4333 37.0835 20.2374L22.2023 34.8208C21.796 35.2166 21.271 35.4166 20.7439 35.4166Z",
    fill: "#2942FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlue);
export default __webpack_public_path__ + "static/media/checked-blue.fa1b3ec01c898d9511113149c7f7c273.svg";
export { ForwardRef as ReactComponent };